'use client'

import { useState } from 'react'
import { useRouter, useSearchParams } from 'next/navigation'
import { Search } from 'lucide-react'
import { Button } from '@/core/components/button'
import { Input } from '@/core/components/input'

/**
 * Live search box for the marketing Explore Hives page. Submitting navigates to
 * `/explore-hives?q=…`; the (server) page re-fetches real discover results for
 * that query. Kept as a thin client island so the page itself can stay a Server
 * Component that talks to the Go backend.
 */
export function HiveSearchBox({ initialQuery = '' }: { initialQuery?: string }) {
  const router = useRouter()
  const searchParams = useSearchParams()
  const [query, setQuery] = useState(initialQuery)

  function submit() {
    const params = new URLSearchParams(searchParams.toString())
    const trimmed = query.trim()
    if (trimmed) {
      params.set('q', trimmed)
    } else {
      params.delete('q')
    }
    const qs = params.toString()
    router.push(qs ? `/explore-hives?${qs}` : '/explore-hives')
  }

  return (
    <div className="max-w-2xl mx-auto mb-8">
      <div className="relative">
        <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-muted-foreground w-5 h-5" />
        <Input
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') submit()
          }}
          placeholder="Search for hives..."
          className="pl-12 pr-4 py-6 text-lg rounded-full border-2"
          aria-label="Search hives"
        />
        <Button
          variant="gradient"
          size="lg"
          className="absolute right-2 top-1/2 -translate-y-1/2 rounded-full"
          onClick={submit}
        >
          Search
        </Button>
      </div>
    </div>
  )
}
